import { ERouteHttpVerb } from "@devowl-wp/api";
const routeLocationMediaPost = {
    path: "/media",
    method: ERouteHttpVerb.POST
};
export { routeLocationMediaPost };
